import React, { useRef, useEffect, useState } from 'react'; 
import MainCard from '../../../ui-component/cards/MainCard';
import SecondaryAction from '../../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../../store/constant';
import { Grid, Button, useMediaQuery, CircularProgress, Menu, MenuItem, IconButton } from '@mui/material'; // Added `useMediaQuery`
import RefreshIcon from '@mui/icons-material/Refresh';
import { useSelector } from 'react-redux';
import { models } from 'powerbi-client';
import imageILogo from '../../../assets/images/image-i-logo.png';

function PowerBiReportPage(props) {
    const [reportsData, setReportsData] = useState({
        title: '',
        embedUrl: '',
        isSecure: false,
        reportData: '',
        reportId: '',
        accessToken: '',
        datasetId: '',
        groupId: '',
    });
    const [reportLoaded, setReportLoaded] = useState(false);
    const [menuAnchor, setMenuAnchor] = useState(null);    
    const reportRef = useRef(null);
    const customization = useSelector((state) => state.customization);
    const isMobile = useMediaQuery('(max-width:600px)'); // Detect if the screen is mobile
        
    useEffect(() => {
        if (customization.payload) {
            // Reset the Power BI container
            const reportContainer = document.getElementById("reportContainer");
            if (reportContainer) {
                window.powerbi.reset(reportContainer);
            }
    
            // Update state with the new report details
            const { title, embedUrl, reportId, isSecure, accessToken, datasetId, groupId } = customization.payload;
    
            setReportsData({
                title,
                embedUrl: embedUrl || customization.payload.reportData,
                reportId,
                isSecure: isSecure || false,
                accessToken: accessToken || "",
                datasetId,
                groupId
            });
        }
    }, [customization.payload]);

    
    
    const org_id = useSelector((state) =>
        state?.account?.org?.id
          ? state.account.org.id
          : state?.account?.org_data?.data?.id
      );

    const downloadReport = async (format) => {
        if (!reportsData.reportId) {
            console.error('No reportId available for download.');
            return;
        }

        try {
            const token = localStorage.getItem("token");
            const proxyUrl = `https://api.projectivetech.com/user/download-report`;
            //const proxyUrl = `http://localhost:8000/user/download-report`;
            const response = await fetch(
                `${proxyUrl}?report_id=${reportsData.reportId}&format=${format}&org_id=${org_id}`,
                    {
                            method: "GET",
                            headers: {
                                "Authorization": `Bearer ${token}`
                            }
                    }
            
            );

            if (!response.ok) {
                throw new Error("Failed to download the report.");
            }

            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `${reportsData.title || "report"}.${format.toLowerCase()}`;
            link.click();
            window.URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error("Error downloading the report:", error);
        }
    };

    const handleRefreshDataset = async () => {
        const { datasetId, groupId } = reportsData || {};
        console.log("🧪 datasetId:", datasetId);
        console.log("🧪 groupId:", groupId);

        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://api.projectivetech.com/user/refresh_powerbi_dataset', 
            //const response = await fetch('http://localhost:8000/user/refresh_powerbi_dataset',
                {
                method: 'POST',
                headers: { 
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ datasetId, groupId }),
                }
            );

            if (!response.ok) return console.error('Refresh failed');
            setTimeout(() => {
                reportRef.current
                ?.refresh()
                .catch(() => reportRef.current.reload());
            }, 60000);
        } catch (err) {
            console.error('Refresh error', err);
        }
    };

    useEffect(() => {
        const container = document.getElementById('reportContainer');
        if (
        container &&
        reportsData.isSecure &&
        reportsData.embedUrl &&
        reportsData.accessToken &&
        reportsData.reportId
        ) {
        window.powerbi.reset(container);
        setReportLoaded(false);
        const embedConfig = {
            type: 'report',
            id: reportsData.reportId,
            embedUrl: reportsData.embedUrl,
            tokenType: models.TokenType.Embed,
            accessToken: reportsData.accessToken,
            groupId: reportsData.groupId,
            datasetId: reportsData.datasetId,
            settings: {
            layoutType: models.LayoutType.Custom,
            customLayout: { displayOption: models.DisplayOption.FitToWidth },
            panes: { filters: { visible: false } },
            navContentPaneEnabled: false,
            },
        };
        const report = window.powerbi.embed(container, embedConfig);
        reportRef.current = report;
        report.on('loaded', () => setReportLoaded(true));
        report.on('rendered', () => setReportLoaded(true));
        report.on('error', () => setReportLoaded(true));
        }
    }, [reportsData]);

    
    const openMenu = (e) => setMenuAnchor(e.currentTarget);
    const closeMenu = () => setMenuAnchor(null);    
        

    return (
        <MainCard secondary={<SecondaryAction />} style={{ minHeight: '100vh' }}>
        <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
            <span
                style={{
                textDecoration: 'none',
                color: 'gray',
                fontWeight: 500,
                fontSize: isMobile ? '12px' : '14px',
                }}
            >
                {reportsData.title || 'Report Title'}
            </span>
            </Grid>
        </Grid>

        <Grid container spacing={gridSpacing}>
            {reportsData.isSecure ? (
            <Grid item xs={12}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                <IconButton color="primary" onClick={handleRefreshDataset}>
                    <RefreshIcon />
                </IconButton>
                <Button variant="contained" onClick={openMenu}>
                    Actions ▾
                </Button>
                </div>
                <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={closeMenu}
                >
                <MenuItem onClick={() => { downloadReport('PDF'); closeMenu(); }}>
                    Download as PDF
                </MenuItem>
                <MenuItem onClick={() => { downloadReport('PPTX'); closeMenu(); }}>
                    Download as PPTX
                </MenuItem>
                <MenuItem onClick={() => { downloadReport('XLSX'); closeMenu(); }}>
                    Download as Excel
                </MenuItem>
                </Menu>
                <div
                style={{
                    position: 'relative',
                    height: 'calc(100vh - 180px)',
                    width: '100%',
                    minHeight: isMobile ? 400 : 600,
                }}
                >
                {!reportLoaded && (
                    <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#fff',
                        zIndex: 10,
                    }}
                    >
                    <img
                        src={imageILogo}
                        alt="Image-I"
                        style={{ width: 200, marginBottom: 10 }}
                    />
                    <CircularProgress />
                    </div>
                )}
                <div
                    id="reportContainer"
                    style={{
                    width: '100%',
                    height: '100%',
                    opacity: reportLoaded ? 1 : 0,
                    transition: 'opacity 0.3s ease',
                    }}
                />
                <div
                    style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: 30,
                    backgroundColor: '#fff',
                    zIndex: 1000,
                    }}
                />
                </div>
            </Grid>
            ) : (
            <Grid item xs={12} sx={{ px: 0 }}>
                <div
                style={{
                    position: 'relative',
                    overflow: 'hidden',
                    paddingTop: isMobile ? '75%' : '56.25%',
                }}
                >
                {!reportLoaded && (
                    <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#fff',
                        zIndex: 10,
                    }}
                    >
                    <img
                        src={imageILogo}
                        alt="Image-I"
                        style={{ width: 200, marginBottom: 10 }}
                    />
                    <CircularProgress />
                    </div>
                )}
                <iframe
                    title="Report Section"
                    src={reportsData.embedUrl}
                    onLoad={() => setReportLoaded(true)}
                    style={{
                    position: 'absolute',
                    top: 0,
                    left: 'calc(-50vw + 50%)',
                    width: '100vw',
                    height: '78%',
                    border: 'none',
                    opacity: reportLoaded ? 1 : 0,
                    transition: 'opacity 0.3s ease',
                    }}
                />
                <div
                    style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: 30,
                    backgroundColor: '#fff',
                    zIndex: 1000,
                    }}
                />
                </div>
            </Grid>
            )}
        </Grid>
        </MainCard>
    );
    }

    export default PowerBiReportPage;

